// Flag global que liga/desliga os logs de diagnostico periodicos (pacing,
// heartbeat de stats de video, buffer adaptativo, ahead de audio). Os logs
// de erro e eventos reais (decoder error, resync, fila cheia) continuam
// sempre ativos. Controlado pelo item "Logar stats" do menu de contexto.

const DIAG_KEY = 'stream-activity-diag-logs';

function load(): boolean {
  try {
    return localStorage.getItem(DIAG_KEY) === '1';
  } catch {
    return false;
  }
}

let enabled = load();

export function setDiagLogs(value: boolean): void {
  enabled = value;
  try {
    localStorage.setItem(DIAG_KEY, value ? '1' : '0');
  } catch {
    // sem persistencia disponivel: segue so em memoria
  }
}

export function diagLogsEnabled(): boolean {
  return enabled;
}
